export default {
  init($element) {
  },
  finalize($element) {
    $element.find('.question-header').on('click', function() {
      const $thisQuestion = $(this).parent();

      if ($thisQuestion.hasClass('question-open')) {
        // Close this question

        $thisQuestion.removeClass('question-open');
        $thisQuestion.find('.question-content').stop().slideUp(200);
      } else {
        // Close all other questions & open this question

        $element.find('.question-wrap').each(function() {
          if ($(this).get()[0] != $thisQuestion.get()[0]) {
            $(this).removeClass('question-open');
            $(this).find('.question-content').stop().slideUp(200);
          }
        });

        // Open this question
        $thisQuestion.addClass('question-open');
        $thisQuestion.find('.question-content').stop().slideDown(200);
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/frequentlyAskedQuestions.js